import React, { Suspense } from 'react';
import { useLocation } from 'react-router-dom';

import LoadingScreen from '../../components/LoadingScreen';

const ReferralRewardsListComponent = React.lazy(() => import('./components/ReferralRewardsList'));

const ReferralRewardsList = () => {
  const { pathname } = useLocation();
  return (
    <div>
      <Suspense fallback={<LoadingScreen isDashboard={pathname.includes('/dashboard')} />}>
        <ReferralRewardsListComponent />
      </Suspense>
    </div>
  );
};

export default ReferralRewardsList;
